<template>
  <div>
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped>
</style>
